import React from 'react';
import styled from 'styled-components';
import {DeprecatedText as Text} from '@forecast-it/design-system';
import {Link} from 'react-router-dom';
import {
	getNotAllowedReasonEntityLabel,
	TimeRegistrationNotAllowedReason,
} from '../../util/time-registration/time-registration-settings/TimeRegistrationNotAllowedReason';
import {getTaskLink} from '../../util/LinkUtil';

export type InvalidatedTimerTask = {
	taskId: number | null;
	reason: TimeRegistrationNotAllowedReason;
};

const InvalidatedTimerTaskWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	margin-bottom: 8px;
	padding: 8px 12px;
	background-color: #f7f7fe;
	border-radius: 8px;
`;

type TimerTaskInvalidInfoProps = {
	invalidatedTimerTask: InvalidatedTimerTask;
};
function TimerTaskInvalidInfo({invalidatedTimerTask}: TimerTaskInvalidInfoProps): JSX.Element {
	const notAllowedReasonEntityLabel = getNotAllowedReasonEntityLabel(invalidatedTimerTask.reason);
	const taskLink = invalidatedTimerTask.taskId ? getTaskLink(invalidatedTimerTask.taskId) : null;
	const isCurrentLink = window.location.pathname === taskLink;

	const isNonLinkText = isCurrentLink || !taskLink;
	const nonLinkText = isCurrentLink ? 'This task' : 'A task';

	return (
		<InvalidatedTimerTaskWrapper>
			<Text>
				{isNonLinkText ? nonLinkText : <Link to={taskLink}>The task your timer was started on</Link>}
				{` is no longer a valid time registration target because your company does not allow time registrations ${notAllowedReasonEntityLabel}.`}
			</Text>
			<Text>Please select a different task.</Text>
		</InvalidatedTimerTaskWrapper>
	);
}

export default TimerTaskInvalidInfo;
